<div>
  @if (content?.url) {
    <div>
      @if (!youTube && !vimeo) {
        <video #standardVideoPlayer class="video" controls>
          <source [src]="videoUrl" />
        </video>
      }
      @if (youTube) {
        <div #youTubeVideoPlayer class="youtube-player">
          <youtube-player
            #youtubePlayerRef
            (stateChange)="youtubeStateChange($event)"
            [height]="height"
            [playerVars]="youTubeVideoPlayerVars"
            [videoId]="videoId"
            [width]="width"
          />
          <!--      {{width}} x {{height}}-->
          @if (shouldShowCustomThumbnail) {
            <div class="thumbnail-overlay" (click)="playVideo()">
              <img src="https://img.youtube.com/vi/{{videoId}}/maxresdefault.jpg" class="custom-thumbnail" />
              <button class="play-button">▶</button>
            </div>
          }
        </div>

        <img
          [src]="'https://i.ytimg.com/vi_webp/' + videoId + '/sddefault.webp'"
          (load)="onLoad($event)"
          style="display: none"
        />
      }
      @if (vimeo) {
        <iframe #vimeoVideoPlayer [src]="videoUrl" class="vimeo-player"></iframe>
      }
    </div>
  }
</div>
